import { Titlebar } from '@components/Titlebar/Titlebar'
import { Box, Stack, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import NFTsTab from './NFTsTab'
import LearnTab from './LearnTab'
import TokensTab from './TokensTab'
import DappsTab from './DappsTab'
import TabPanel from '@components/TabPanel'

export const DiscoverOverview = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [searchTerm, setSearchTerm] = useState<string>('')

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchTerm('')
    setSelectedTab(newValue)
  }

  return (
    <Stack spacing={1} mt={2} mx={2}>
      <Titlebar title="Discover" />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          variant="scrollable"
          scrollButtons={false}
          value={selectedTab}
          onChange={handleChange}
        >
          <Tab label="Tokens" />
          <Tab label="Dapps" />
          <Tab label="NFTs" />
          <Tab label="Learn" />
        </Tabs>
      </Box>

      <TabPanel value={selectedTab} index={0}>
        <TokensTab />
      </TabPanel>

      <TabPanel value={selectedTab} index={1}>
        <DappsTab searchTerm={searchTerm} />
      </TabPanel>

      <TabPanel value={selectedTab} index={2}>
        <NFTsTab />
      </TabPanel>

      <TabPanel value={selectedTab} index={3}>
        <LearnTab />
      </TabPanel>
    </Stack>
  )
}
